import Emitter from "../utilities/Emitter.js";
import Window from "../stores/Window.js";

export default class Navigation {
  constructor(options) {
    this.$el = options.$el;
    this.$btn = this.$el.querySelector(".js-navigation-open");
    Emitter.on("scroll", this.scroll.bind(this));

    this.scroll();
    this._onBurgerClick = this.onBurgerClick.bind(this);
    this.addEvent();
  }

  addEvent() {
    this.$btn.addEventListener("click", this._onBurgerClick);
  }

  closeMenu() {
    this.$el.classList.remove("is-open");
    document.body.style.overflow = "visible";
  }

  openMenu() {
    this.$el.classList.add("is-open");

    document.body.style.overflow = "hidden";
  }

  onBurgerClick() {
    if (this.isOpen) {
      Emitter.emit("toggleScroll", false);
      this.closeMenu();
    } else {
      Emitter.emit("toggleScroll", true);
      this.openMenu();
    }
    this.isOpen = !this.isOpen;
  }

  scroll() {
    if (Window.scroll > 10) {
      if (!this.hasScrolled) {
        this.hasScrolled = true;
        this.showWhite();
      }
    } else {
      if (
        this.hasScrolled &&
        !document.documentElement.classList.contains("scrollDisabled")
      ) {
        this.hasScrolled = false;
        this.showTransparent();
      }
    }
  }

  showTransparent() {
    this.$el.classList.remove("is-white");
  }

  showWhite() {
    this.$el.classList.add("is-white");
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Navigation.js